
const INITIAL_STATE = {}

const stockReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_STOCK":
                        return { ...state, listaStock: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                // Inicia state Modal               
                case "GET_DATA_BUSCALOG":
                        return { ...state, ListaBscLogs: action.payload.data}
                        
                case "GET_DATA_LSTUSUREVENDA":
                        return { ...state, ListaTdsUsuariosRev: action.payload.data }

                // Fim state Modal   
                default:
                        return state
        }
}
export default stockReducer;
